import { render, staticRenderFns } from "./HighchartsComponents.vue?vue&type=template&id=38a96ad6&"
import script from "./HighchartsComponents.vue?vue&type=script&lang=js&"
export * from "./HighchartsComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports